module.exports = __webpack_public_path__ + "img/cdnService.81123a9.svg";